import LinkVerificationError from "../../app/pages/CertificateManagement/BankRep/LinkVerificationError";
import OTPVerification from "../../app/pages/CertificateManagement/BankRep/OTPVerification";
import DigitalLetterExternalResponse from "../../app/pages/DigitalLetter/DigitalLetterExternalResponse";

import { appUrls } from "../../utils/urls/appUrls";
import { notapRoutes } from "./notapRoutes";
import { onBoardRoutes } from "./onBoardRoutes";

export const generalRoutes = [
	{
		url: appUrls.bank_digital_letter_external,
		component: <DigitalLetterExternalResponse />,
		routeType: 'public'
	},
	{
		url: appUrls.upload_certificate_of_reasonableness,
		component: <OTPVerification />,
		routeType: 'public'
	},
	{
		url: appUrls.upload_link_verification_error,
		component: <LinkVerificationError />,
		routeType: 'public'
	},
    ...onBoardRoutes, 
    ...notapRoutes
];